import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServerRootService } from '@se/se.ui.html5';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class WadoService extends ServerRootService {

    private readonly apiController: string;

    constructor(private httpClient: HttpClient) {
        super();

        this.apiController = `${this.getServerRoot()}/Wado`;
    }

    get(objectUID: string, contentType: string = 'application/pdf'): Observable<ArrayBuffer> {
        const params = {
            contentType,
            objectUID,
        };

        return this.httpClient.post(`${this.apiController}/WadoProxyGeneric`, params, {
            responseType: 'arraybuffer',
        });
    }

    getBase64(objectUID: string, contentType: string = 'application/pdf') {
        const params = {
            contentType,
            objectUID,
        };

        return this.httpClient.post<string>(`${this.apiController}/WadoProxyGeneric`, params, this.buildOptions());
    }

    getWadoPdf(objectUID: string, contentType: string = 'application/pdf') {
        const params = {
            contentType,
            objectUID,
        };

        return this.httpClient.post<string>(`${this.apiController}/WadoProxyGenericByteArray`, params, this.buildOptions());
    }

    // TODO: 34.13: TROVARE FIX DEFINITIVO
    getEcgPdf(reportIds: string[], displayedSettings: any, ignoreErrors: boolean = false) {
        return this.httpClient.post<string>(this.getServerRoot() + "/ECG/GetPdf", { reportIds, displayedSettings }, this.buildOptions(null, ignoreErrors));
    }

    getVisitPdf(reportIds: string[], displayedSettings: any, smCertificateCode?: string) {
        return this.httpClient.post<string>(this.getServerRoot() + "/Visit/GetPdf", { reportIds, displayedSettings, smCertificateCode }, this.buildOptions());
    }
}
